import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { SplitContentChannelConfig } from "../splitContentTypes";
import { PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ChannelSelectGuid } from "@/pages/channel/ChannelSelectGuid";

interface Props {
  onClose: () => void;
  onAttached: (config: SplitContentChannelConfig) => void;
  currentConfig?: SplitContentChannelConfig;
  defaultScreenSizeGuid: string;
}

export const SplitContentAttachChannelDialog: React.FC<Props> = ({
  onClose,
  onAttached,
  currentConfig,
  defaultScreenSizeGuid,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogTrigger>
        <span className="flex items-center gap-2">
          {t("common.assign")} <PlusIcon className="w-4 h-4" />
        </span>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="mb-2">{t("splitContent.attachChannel")}</DialogTitle>
          <DialogDescription className="flex flex-col gap-4">
            <ChannelSelectGuid
              defaultScreenSizeGuid={defaultScreenSizeGuid}
              onChange={(channel) => {
                const conf: SplitContentChannelConfig = {
                  type: "channel",
                  channelGuid: channel.id,
                };
                onAttached(conf);
                onClose();
              }}
              selectedChannelGuid={currentConfig?.channelGuid}
            />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
